import Immutable from 'immutable'

export const IpnRecord = Immutable.Record({
  master: null,
  member: null,
}, 'ServiceIpnRecord')

export default function createServiceIpn(data) {
  return new IpnRecord(data)
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/Service/Ipn.js